import TextField, {
    TextFieldProps,
} from '@ilg-totallymoney/ui/components/TextField'
import { FieldProps, getIn } from 'formik'

function FormikTextField<
    Value extends string | number | readonly string[] | undefined = any,
>({
    field,
    form,
    ...props
}: FieldProps<Value> & TextFieldProps): React.ReactElement {
    const validationMessage = getIn(form.errors, field.name) as string
    const isTouched = getIn(form.touched, field.name) as boolean

    return (
        <TextField
            {...field}
            validationMessage={validationMessage}
            touched={isTouched}
            {...props}
        />
    )
}

export default FormikTextField
